import React from "react";
import { TextField, MenuItem } from "@mui/material";

import { motion } from "framer-motion";
import { formVariant, propertyTypes } from "../../utility/constains";

const PropertyAreaFields = ({
  propertyType,
  area,
  unit,
  setPropertyType,
  setArea,
  setUnit,
}) => (
  <motion.div
    className="flex flex-col md:flex-row gap-4"
    initial="hidden"
    animate="visible"
    custom={1}
    variants={formVariant}
  >
    <TextField
      select
      label="Type of Property"
      fullWidth
      value={propertyType}
      onChange={(e) => setPropertyType(e.target.value)}
      variant="outlined"
      InputProps={{
        className:
          "focus:ring-2 focus:ring-green-500 focus:border-green-500 hover:ring-green-600",
      }}
      InputLabelProps={{
        className: "text-green-600",
      }}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            className: "noScrollbar",
          },
        },
      }}
    >
      {Object.keys(propertyTypes).map((type) => (
        <MenuItem
          key={type}
          value={type}
          className="hover:bg-green-500 hover:text-green-500"
        >
          {type}
        </MenuItem>
      ))}
    </TextField>

    <TextField
      label="Area"
      fullWidth
      value={area}
      onChange={(e) => setArea(e.target.value)}
      type="number"
      variant="outlined"
      InputProps={{
        className:
          "focus:ring-2 focus:ring-green-500 focus:border-green-500 hover:ring-green-600",
      }}
      InputLabelProps={{
        className: "text-green-600",
      }}
    />
  </motion.div>
);

export default PropertyAreaFields;
